import {
  ChangeDetectionStrategy,
  Component,
  ContentChild,
  EventEmitter,
  Input,
  Output,
  TemplateRef
} from '@angular/core';

@Component({
  selector: 'oir-selectable-list',
  templateUrl: './selectable-list.component.html',
  styleUrls: ['./selectable-list.component.less'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class SelectableListComponent {

  @Input() list: any;
  @Input() trackBy: string;
  @ContentChild('lineContent') lineContentTmpl: TemplateRef<any>;
  @Output() readonly onItemSelect = new EventEmitter<any>();

  trackByFn(index, item): number {
    if (this.trackBy != null) {
      return item[this.trackBy];
    }
    return index;
  }

  itemSelected(item): void {
    this.list.forEach(element => {
      element.selected = false;
    });
    item.selected = true;
    this.onItemSelect.emit(item);
  }
}
